export default [
  {
    path: '/estoque',
    name: 'Estoque',
    component: () => import(/* webpackChunkName: "Estoque" */ '../estoque/Estoque')
  }
]



// WEBPACK FOOTER //
// ./src/pages/estoque/router.js